import axios from "axios";

function getProgrammeCards(client_access_key, bearerToken) {
  return axios
    .get(`${process.env.REACT_APP_API_2_ENDPOINT}/card-identifiers`, {
      headers: {
        Authorization: "Bearer " + bearerToken,
        client_access_key: `${client_access_key}`,
      },
    })
    .then(response => {
      return response.data;
    });
}

export default getProgrammeCards;
